import { useState } from "react";

import { useMe } from "../api/me";
import { useSendTestMessage, useUnpairTelegram } from "../api/telegram";
import AdminUsersSection from "../components/AdminUsersSection";
import AlertRulesPanel from "../components/AlertRulesPanel";
import DeleteAccountSection from "../components/DeleteAccountSection";
import Footer from "../components/Footer";
import MyFeedbackSection from "../components/feedback/MyFeedbackSection";
import NotificationPrefsGrid from "../components/NotificationPrefsGrid";
import PageHeader from "../components/PageHeader";
import PairTelegramDialog from "../components/PairTelegramDialog";
import TopNav from "../components/TopNav";
import { isAdmin } from "../lib/admin";

export default function Settings() {
  const me = useMe();
  const [pairOpen, setPairOpen] = useState(false);
  const unpair = useUnpairTelegram();
  const test = useSendTestMessage();
  const paired = me.data?.telegram_paired ?? false;
  const showAdmin = isAdmin(me.data?.email);

  return (
    <div className="mx-auto max-w-3xl p-4 sm:p-6">
      <PageHeader />
      <TopNav />
      <h1 className="mb-6 text-xl font-semibold tracking-tight text-slate-100 sm:text-2xl">
        Settings
      </h1>

      <section className="rounded-2xl border border-slate-800 bg-slate-900/60 p-5">
        <div className="mb-1 flex items-center gap-2">
          <h2 className="text-base font-semibold text-slate-100">Telegram notifications</h2>
          {paired && (
            <span className="rounded-full bg-emerald-500/15 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-emerald-400">
              paired
            </span>
          )}
        </div>
        <p className="mb-4 text-sm text-slate-400">
          Watchlist news, earnings reminders, score shifts and more, sent to your Telegram.
        </p>

        {!paired ? (
          <button
            onClick={() => setPairOpen(true)}
            className="rounded-lg bg-sky-500 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-sky-400 active:bg-sky-600"
          >
            Pair Telegram
          </button>
        ) : (
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => test.mutate()}
              disabled={test.isPending}
              className="rounded-lg border border-slate-700 px-3 py-2 text-sm text-slate-200 transition hover:bg-slate-800 disabled:opacity-50"
            >
              {test.isPending ? "Sending…" : "Send test message"}
            </button>
            <button
              onClick={() => {
                if (confirm("Unpair Telegram? You'll stop receiving notifications.")) {
                  unpair.mutate();
                }
              }}
              disabled={unpair.isPending}
              className="rounded-lg border border-rose-900 px-3 py-2 text-sm text-rose-300 transition hover:bg-rose-950/40 disabled:opacity-50"
            >
              Unpair
            </button>
          </div>
        )}

        {test.isSuccess && (
          <p className="mt-3 text-xs text-emerald-400">Sent.</p>
        )}
        {test.isError && (
          <p className="mt-3 text-xs text-rose-300">Failed: {test.error.message}</p>
        )}
      </section>

      {paired && (
        <section className="mt-6 rounded-2xl border border-slate-800 bg-slate-900/60 p-5">
          <h2 className="mb-4 text-base font-semibold text-slate-100">Categories</h2>
          <NotificationPrefsGrid />
        </section>
      )}

      {paired && (
        <section className="mt-6 rounded-2xl border border-slate-800 bg-slate-900/60 p-5">
          <h2 className="mb-1 text-base font-semibold text-slate-100">Score alerts</h2>
          <p className="mb-4 text-xs text-slate-500">
            Banded buy/sell signals on the AI score, per horizon.
          </p>
          <AlertRulesPanel />
        </section>
      )}

      {me.data?.authenticated && <MyFeedbackSection />}

      {showAdmin && <AdminUsersSection />}

      {me.data?.authenticated && <DeleteAccountSection me={me.data} />}

      <PairTelegramDialog open={pairOpen} onClose={() => setPairOpen(false)} />

      <Footer />
    </div>
  );
}
